import React from "react"
import { Box, Typography, Button, Container } from "@mui/material"
import { useNavigate } from "react-router-dom"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"
import { useTranslation } from "react-i18next"

const NotFoundPage: React.FC = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const handleGoHome = () => {
        navigate("/home")
    }

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "100vh",
                    textAlign: "center",
                }}
            >
                <ErrorOutlineIcon
                    sx={{ fontSize: 80, color: "error.main", mb: 2 }}
                />
                <Typography variant="h2" component="h1" gutterBottom>
                    404
                </Typography>
                <Typography variant="h5" component="h2" gutterBottom>
                    {t("notFoundPage.title")}
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph>
                    {t("notFoundPage.description")}
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleGoHome}
                >
                    {t("notFoundPage.actions.goHome")}
                </Button>
            </Box>
        </Container>
    )
}

export default NotFoundPage
